// @flow

/**
 * Module dependencies.
 */

import { Button } from 'client/components/core/buttons';
import { branch } from 'core/utils';
import { colors, units } from 'client/styles';
import { compose, defaultProps } from 'recompose';
import { position } from 'polished';
import Icon from 'client/components/core/icon';
import Layout from 'client/components/core/layout';
import RawHtml from 'react-raw-html';
import React from 'react';
import Text from 'client/components/core/type';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  button: string,
  buttonAction?: Function,
  buttonThemeColor?: string,
  message: string,
  renderIcon?: boolean,
  title: string,
  visible: boolean
};

/**
 * `AbsoluteCenter` component.
 */

const AbsoluteCenter = styled(Layout)`
  ${position('absolute', '0', '0', '0', '0')}

  align-items: center;
  background-color: ${colors.white};
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  transition: transform .4s ease, opacity .1s linear;
  z-index: 5;

  ${({ active }) => `
    opacity: ${active ? 1 : 0};
    pointer-events: ${active ? 'all' : 'none'};
    transform: translate3d(0, ${active ? '0' : '40px'}, 0);
  `}
`;

/**
 * `SuccessMessageComponent` component.
 */

function SuccessMessageComponent(props: Props): React$Element<*> {
  const {
    button,
    buttonAction,
    buttonThemeColor,
    message,
    title,
    renderIcon,
    visible
  } = props;

  return (
    <AbsoluteCenter active={visible}>
      <div>
        {branch(title,
          <Text.H3
            color={colors.brandSecondary}
            weight={400}
          >
            {title}
          </Text.H3>
        )}

        {branch(renderIcon,
          <Icon
            color={colors.brandPrimary}
            icon={'check'}
            size={'100px'}
          />
        )}

        {branch(message,
          <Layout paddingBottom={units(4)}>
            <Text.Paragraph color={colors.brandSecondary}>
              <RawHtml.div>
                {message}
              </RawHtml.div>
            </Text.Paragraph>
          </Layout>
        )}

        <Button
          element={'a'}
          href
          onClick={buttonAction}
          themeColor={buttonThemeColor}
        >
          {button}
        </Button>
      </div>
    </AbsoluteCenter>
  );
}

/**
 * Export `SuccessMessage`.
 */

export const SuccessMessage = compose(
  defaultProps({
    renderIcon: true
  })
)(SuccessMessageComponent);



// WEBPACK FOOTER //
// ../src/client/components/forms/components/messages/success.js